import { handleSSOCallback, ssoSearchSchema } from '@connected/api-client/lib/sso';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { queryClient } from '@/lib/query-client';

export const Route = createFileRoute('/(shared)/sso/')({
    validateSearch: ssoSearchSchema,
    beforeLoad: async ({ search }) => {
        // console.log('SSO: Received search params:', search);
        // console.log('SSO: Token present:', !!search.token);
        // console.log('SSO: Redirect param:', search.redirect);

        // If no token provided, redirect to login (not to another app to avoid loop)
        if (!search.token) {
            console.error('SSO: No token provided in URL');
            throw redirect({
                to: '/login',
            });
        }

        try {
            const redirectTo = await handleSSOCallback({
                searchParams: search,
                queryClient,
                fallbackRedirect: '/',
            });

            // console.log('SSO: handleSSOCallback returned redirectTo:', redirectTo);

            throw redirect({
                to: redirectTo,
            });
        }
        catch (e) {
            // If it's a TanStack Router redirect, re-throw it
            if (typeof e === 'object' && e !== null && 'to' in e) {
                // console.log('SSO: Redirecting to:', (e as { to: string }).to);
                throw e;
            }

            // If it's a Response object (e.g., from TanStack Router internal redirect), re-throw it
            if (e instanceof Response) {
                // console.log('SSO: Received Response object, re-throwing:', e.status);
                throw e;
            }

            // For any other error, log it and redirect to login locally
            // Do NOT redirect to another app to avoid infinite loop
            console.error('SSO authentication failed:', e);
            throw redirect({
                to: '/login',
            });
        }
    },
    component: SSOPage,
});

function SSOPage() {
    return (
        <div className="flex h-full w-full items-center justify-center">
            <p>Setting up authentication...</p>
        </div>
    );
}
